import '../libs/mmenu/jquery.mmenu.all';

const initializeMobileMenu = () => {
	let menu = $( '.mobile-menu' ).mmenu( {
			extensions: ['theme-dark'],
		} ),
		icon = $( '.hamburger' ),
		api = menu.data( 'mmenu' );

	icon.on( 'click', function() {
		api.open();
	} );
};

const desktopMenuHover = () => {
	var firstLevelMenuItems = document.querySelectorAll(
		'.main-menu .menu__link--level-1' );
	var hoverClass = 'menu__item--hover';

	firstLevelMenuItems.forEach( ( item ) => {
		var menuEnterTimeout = null;
		var parentItem = item.parentElement;
		item.addEventListener( 'mouseenter', ( e ) => {
			menuEnterTimeout = setTimeout( () => {
				parentItem.classList.add( hoverClass );
			}, 200 );
		} );

		item.addEventListener( 'mouseleave', ( e ) => {

			if (menuEnterTimeout !== null) {
				clearTimeout( menuEnterTimeout );
			}

			setTimeout( () => {
				if (parentItem.classList.contains( hoverClass )) {
					parentItem.classList.remove( hoverClass );
				}
			}, 200 );

		} );
	} );
};

export {initializeMobileMenu,desktopMenuHover}
